<template>
  <div class="row mt-2 row-container">
    <div class="col-2 col-sm col-12 border-right status">
      <balloon
        bg="bg-secondary-19"
        class="mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center w-80 ml-3"
        color="color-secondary-20 font-weight-bold"
        text="Error"
        :with-border="false"
      />
    </div>
    <div class="col-3 col-sm col-12 pl-3 pl-md-4 pl-sm-4 mt-4 mt-md-0 mt-sm-4">
      <div class="color-secondary-6 font-14">Estudiante:</div>
      <span class="color-black font-16 font-weight-bold">
        {{ value.studentSieId }} - {{ value.fullName | capitalize }}
      </span>
    </div>
    <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4">
      <div class="color-secondary-6 font-14">Servicio:</div>
      <span class="color-black font-16 font-weight-normal">
        {{ value.serviceDescription }}
      </span>
    </div>
    <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4">
      <div class="color-secondary-6 font-14">Periodo:</div>
      <span class="color-black font-16 font-weight-normal">
        {{ value.period }}
      </span>
    </div>
    <div class="col-3 col-sm col-12 mt-4 mt-md-0 mt-sm-4">
      <div class="color-secondary-6 font-14">Razón:</div>
      <span class="color-black font-16 font-weight-normal">
        <custom-error
          :message="value.reason"
          variant="no-border ml-n1 reason"
        />
      </span>
    </div>
    <div class="col d-flex align-items-center justify-content-end pr-5">
      <action-button
        i="fas fa-comment"
        variant="outline-success"
        @click="setComment"
      >
        Comentario
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomError from 'custom-error';
import ActionButton from 'ActionButton';
export default {
  name: 'FindingRow',
  components: {
    CustomError,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    setComment() {
      this.$emit('on-set-finding-comment', true);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

@media only screen and (max-width: 768px) {
  .row-container {
    div,
    span {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
    .status {
      border-right: unset !important;
      border-bottom: 1px solid map-get($colors, 'secondary-12');
      padding-bottom: map-get($fontsSize, 'font-10');
    }
  }
  ::v-deep .reason {
    em {
      font-size: map-get($fontsSize, 'font-10') !important;
    }
    .text-left {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
  }
}
</style>
